define('views/modules/calendar/nutrition/food/suggestion/list/food-suggestion-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/modules/calendar/nutrition/food/list/food-list-item',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VFoodItem
) {

    var VFoodSuggestionItem = VFoodItem.extend({
        className: 'food-suggestion-item',
        getData: function() {
            return { name: this.model.get('text') };
        },

        isFavorite: function() {
            return false;
        }
    });

    return VFoodSuggestionItem;

});

